module.exports = __webpack_public_path__ + "videos/completo-video.12b941c.mp4";